var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "left-menu-wrapper"
  }, [_c('v-btn', {
    staticClass: "left-menu-toggler pl-3",
    attrs: {
      "plain": "",
      "title": _vm.mini ? 'Показать меню' : 'Скрыть меню'
    },
    on: {
      "click": function click($event) {
        _vm.mini = !_vm.mini;
      }
    }
  }, [_c('v-icon', {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.mini ? 'mdi-chevron-double-right' : 'mdi-chevron-double-left'))])], 1), _c('v-navigation-drawer', {
    staticClass: "background left-menu",
    attrs: {
      "clipped": false,
      "width": "300",
      "mini-variant": _vm.mini,
      "absolute": "",
      "app": "",
      "floating": "",
      "mobile-breakpoint": "xs",
      "permanent": ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c('MenuLinks', {
    attrs: {
      "links": _vm.links
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }